module.exports = __webpack_public_path__ + "img/KTMD Malaysia.70cd4471.png";